//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    priceList: {
      type: Object,
      required: true
    },
  },
  computed: {
    priceListItem () {
      return this.priceList.items[0]
    },
    features () {
      return this.priceList.data.features
    },
    itemFeatures () {
      return this.features.reduce((acc, cur) => {
        const itemFeature = this.priceListItem.data.features.find(f => f.id === cur.id)
        if (itemFeature) {
          return [...acc, { ...cur, ...itemFeature }]
        }

        return acc
      }, [])
    },
  }
}
